import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WarehouseMaterialStockAdapter } from '../adapters/WarehouseMaterialStockAdapter';
import { CreateStockAdjustmentRequest } from '../models/WarehouseMaterialLocation';

export function useAdjustWarehouseMaterialStock() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateStockAdjustmentRequest) => {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new WarehouseMaterialStockAdapter(httpClient);
      await adapter.adjustStock(payload);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['materialAlmacen'] });
      queryClient.invalidateQueries({
        queryKey: ['warehouse-material-assigned-locations', variables.product_id],
      });
    },
  });
}
